import { render, staticRenderFns } from "./bsmeterweek.vue?vue&type=template&id=17573818&"
import script from "./bsmeterweek.vue?vue&type=script&lang=js&"
export * from "./bsmeterweek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports